import { network } from 'services/network';

export const customerGet = (params) => {
    return network.get(`api/bo/customer/get/${params.customerId}`).then((response) => response.data);
};
